class BlockadeLabs {
    constructor(url, apiKey) {
        this.url = url;
        this.apiKey = apiKey;
    }
    async create360Image(prompt) {
        try {
            const response = await fetch(this.url, {
                method: 'POST',
                body: {
                    api_key: this.apiKey,
                    prompt,
                    skybox_style_id: 10,
                },
            });
            return response.json();
        } catch (err) {
            console.log(err);
        }
    }
}

export default new BlockadeLabs(
    'https://backend.blockadelabs.com/api/v1/skybox?api_key=QKl8wn3jNfTg7PpyETFRKGK6mPcPiRsLRQb6pBN79RGev6xoq7cwXL0HKrEO',
    'QKl8wn3jNfTg7PpyETFRKGK6mPcPiRsLRQb6pBN79RGev6xoq7cwXL0HKrEO'
);
